import { Button, ButtonProps } from "primereact/button";
import { CSSProperties, useId } from "react";

export type ToastOrionProps = {
  title: string;
  description?: string;
  actionButton?: ButtonProps;
  type?: "success" | "error" | "info" | "loading" | "warning";
  variant?: "primary" | "secondary";
};

type ToastActionButton = ButtonProps & {
  toastType?: ToastOrionProps["type"];
};

function ToastActionButton({ toastType, ...props }: ToastActionButton) {
  const style: CSSProperties = {};
  if (toastType === "error") {
    style.color = "var(--toastify-color-error)";
  } else if (toastType === "info") {
    style.color = "var(--toastify-color-info)";
  } else if (toastType === "success") {
    style.color = "var(--toastify-color-success)";
  } else if (toastType === "warning") {
    style.color = "var(--toastify-color-warning)";
  }

  return (
    <Button
      link
      className="ml-auto mt-1 font-semibold hover:bg-slate-200 hover:text-black"
      style={style}
      {...props}
    />
  );
}

export function ToastOrion({ title, description, type, actionButton }: Readonly<ToastOrionProps>) {
  const id = useId();

  const titleId = `toast-title-${id}`;
  const descriptionId = description ? `toast-description-${id}` : undefined;
  return (
    <div
      aria-describedby={descriptionId}
      aria-labelledby={titleId}
      aria-live="assertive"
      className="toast-orion ml-2 flex flex-col"
    >
      <h3 className="text-base font-semibold" id={titleId} role="heading">
        {title}
      </h3>
      {description && (
        <p className="text-[0.8125rem]" id={descriptionId}>
          {description}
        </p>
      )}
      {actionButton && <ToastActionButton toastType={type} {...actionButton} />}
    </div>
  );
}

ToastOrion.ActionButton = ToastActionButton;
